<template>
  <div class="content">
    <div class="content_title">
      Список организаций
    </div>
    <div class="form-row-line">
      <div class="form-field">
        <router-link tag="button" to="/backoffice/org/org-add">
          <span>Добавить организацию</span>
        </router-link>
      </div>
    </div>
    <div class="content_row" v-for="(org, key) in orgs" :key="key">
      <div>{{ org.SHORT_NAME }}</div>
      <div>{{ org.GEN_DIR }}</div>
    </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "GetCompanies",
  data() {
    return {
      url: config.backend_url,
      orgs: []
    };
  },
  methods: {
    getOrgs: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "companies/get-user-companies/",
          data: {},
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          if (!data.error) this.orgs = data;
        });
    }
  },
  created() {
    this.getOrgs();
  }
};
</script>
